import { CalendarClock, Clock, Receipt, Workflow } from "lucide-react";
import { Link } from "react-router-dom";
import { Empty } from "../components/ui";
import type { AppId, Me } from "../lib/api";

const ICONS: Record<AppId, typeof Workflow> = { ja: Workflow, expense: Receipt, time: Clock, payables: CalendarClock };

/** App tiles for the apps this user is entitled to (design §7). */
export default function Launcher({ me }: { me: Me }) {
  const apps = me.apps ?? [];
  return (
    <div>
      <h1 className="text-2xl font-bold text-ink mb-1">Welcome{me.name ? `, ${me.name.split(" ")[0]}` : ""}</h1>
      <p className="text-sm text-muted mb-6">Your Intellias apps for {me.tenant!.name}.</p>
      {apps.length === 0 ? (
        <Empty icon={<Workflow className="size-8" />} title="No apps yet">
          {me.tenantAdmin ? "Give yourself or your team an app on the Users page." : "Your administrator hasn't given you any apps yet."}
        </Empty>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {apps.map((a) => {
            const Icon = ICONS[a.id];
            return (
              <Link key={a.id} to={`/apps/${a.id}`} className="group rounded-2xl border border-line bg-surface p-5 hover:border-accent transition-colors">
                <div className="size-11 rounded-xl brand-bar text-white inline-flex items-center justify-center mb-4">
                  <Icon className="size-5" aria-hidden />
                </div>
                <div className="font-display font-semibold text-ink group-hover:text-accent-text">{a.name}</div>
                <div className="text-xs text-muted mt-1 capitalize">{a.role}</div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
